import helpers from './Helpers/helpers';
import cogoToast from 'cogo-toast';
import moment from 'moment';

// Import Fonts
import './static/fonts/MediaSans/mediasans.css';
import './static/fonts/ParaSupreme/parasupreme.css';
import './static/fonts/Tobias/tobias.css';

window.__IS_PRO__ = helpers.isPro();
window.__IS_SMS__ = helpers.isSMS() || helpers.isSnap();
window.__IS_SNAP__ = helpers.isSnap();
window.__IS_DEV__ = helpers.isDevelopment();
window.__IS_PROD__ = helpers.isProduction();
window.__ROOT_SCSS__ = helpers.getRootSCSSClass();

// For locking of the catalog for only product id matches
window.LOCK_CATALOG_MATCHES_ONLY = false;

// To make it easier to alert from everywhere
window.ALERT = cogoToast;

// For admin control mode without requiring extensive imports
export const setGlobalAdminControlMode = turnOn => {
  window.__ADMIN_CONTROL_MODE__ = turnOn;

  // Manage feature flags
  if (!window.__IS_NEW_OPPS_BONUS_MODE_LIVE__ && turnOn) {
    window.__IS_NEW_OPPS_BONUS_MODE_LIVE__ = true;
  }
};

// Feature Flags
window.__IS_NEW_OPPS_BONUS_MODE_LIVE_DATE__ = '2025-05-01T00:00:00Z';
window.__IS_NEW_OPPS_BONUS_MODE_LIVE__ = moment().isAfter(window.__IS_NEW_OPPS_BONUS_MODE_LIVE_DATE__);
window.__IS_NEW_OPPS_BONUS_MODE_LIVE_CHANGE_NOTIFICATIONS_OFF__ = moment().isAfter('2025-07-01T00:00:00Z');
